module.exports = __webpack_public_path__ + "static/media/UGC-new1.1777f352.png";